/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { FirmwareRowFragmentDoc } from '../../components/firmware/__generated__/FirmwareTable.graphql';
import { PlatformFirmwareReleaseFragmentDoc } from '../../components/firmware/__generated__/CreateAndroidFirmwareReleaseModal.graphql';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type GetAllPlatformsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAllPlatformsQuery = { __typename?: 'Query', platforms: Array<{ __typename?: 'Platform', id: string, name: string, version?: string | null, description?: string | null, type: Types.PlatformType, firmwareReleases: { __typename?: 'FirmwareReleases', android: Array<{ __typename?: 'AndroidFirmware', version: any, url?: string | null, scalarVersion?: string | null }> } }> };


export const GetAllPlatformsDocument = gql`
    query GetAllPlatforms {
  platforms {
    id
    ...FirmwareRow
    ...PlatformFirmwareRelease
  }
}
    ${FirmwareRowFragmentDoc}
${PlatformFirmwareReleaseFragmentDoc}`;

/**
 * __useGetAllPlatformsQuery__
 *
 * To run a query within a React component, call `useGetAllPlatformsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPlatformsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPlatformsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPlatformsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllPlatformsQuery, GetAllPlatformsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAllPlatformsQuery, GetAllPlatformsQueryVariables>(GetAllPlatformsDocument, options);
      }
export function useGetAllPlatformsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllPlatformsQuery, GetAllPlatformsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAllPlatformsQuery, GetAllPlatformsQueryVariables>(GetAllPlatformsDocument, options);
        }
export type GetAllPlatformsQueryHookResult = ReturnType<typeof useGetAllPlatformsQuery>;
export type GetAllPlatformsLazyQueryHookResult = ReturnType<typeof useGetAllPlatformsLazyQuery>;
export type GetAllPlatformsQueryResult = ApolloReactCommon.QueryResult<GetAllPlatformsQuery, GetAllPlatformsQueryVariables>;